import FJAIPhotoEditorConfig from '../appConfig/FJAIPhotoEditorConfig';
import FJConfig from '../FJConfig';
import { TAGS, CATEGORIES } from '../../constants/FJModelAttributesConstant';

// 智能编辑预设
export const SMART_IMAGE_INSTRUCTION_TEMPLATES = [
    {
        id: 'character-sheet',
        templateName: 'character-sheet',
        text: 'character-sheet-desc',
        preValue: [],
        placeholder: [],
        result: `Generate a 3:4 cartoon picture book-style image based on the character in the reference image.With a soft solid-color background. Format: 3:4Style: Picture book style × hand-drawn × soft color paletteColor Scheme: Refer to the attached image【Layout】Prominently place "Character Name" in the center of the imageRandomly distribute circular speech bubble-style information blocks around the centerThe speech bubbles feature soft hand-drawn lines and are filled with light gradient colorsEach speech bubble contains short text + small illustrations【Introduction Items】Appearance (Basic Form): 〇〇Favorite Things: 〇〇Special Skill: 〇〇Personality: 〇〇Little Secret: 〇〇Partner: 〇〇Catchphrase: 〇〇Motto: 〇〇【Visual Effects】Decorate the gaps and corners with small icons related to the character's themeArrange the speech bubbles randomly in a staggered top-bottom layout to create a lively and bustling visual effect`,
    },
    {
        id: 'snack-mockup',
        templateName: 'snack-mockup',
        text: 'snack-mockup-desc',
        preValue: [],
        placeholder: [],
        result: `create A hyper-realistic photograph of a hand holding a snack package. In the background, a shelf lined with the character from the reference image alongside various snack packages of different flavors and types is also visible.Character Name: 「Name」Snack Setting:「〇〇」If not specified, randomly select one category from all snacks sold in convenience stores, supermarkets, and confectionery shops. The design should emphasize a quirky or trendy vibe.A realistic-style photograph depicting a hand holding an original snack package themed around the character from the reference image.The design must be natural enough to look completely in place when displayed in a store.The surroundings of the snack should realistically present an in-store scene.Snack Package Design RequirementsIncorporate the character from the reference image into the package design.The snack name should highlight the features of the reference image with strong humor.The package should adopt a hyper-realistic, high-quality, and mouth-watering premium design.Realistically render gloss reflection effects and material textures.Attach an appetizing photo of the snack inside.Areas other than the decorative sections should be made of transparent plastic, or feature a transparent film window that allows a view of the contents.Based on the reference image, prominently display multiple humorous and exaggerated slogans and product names in a font that reflects the image’s mood.Create a background (store display scene) that aligns with the snack’s overall concept.Ensure the background and the package concept maintain coherence in emotional tone and color application.📦 Snack Package Shape RandomizerRegardless of the snack type, randomly select one shape from the list below with equal probability.Ensure the shape is coordinated with the background, texture, and lighting effects.◆ List of Shape Categories (12 Types Total)Vertical pouch packaging (for chips & snacks)Horizontal pouch packaging (for chocolate bars & stick snacks)Box (small) (for candies & lemon drops)Box (large) (for family-size packs)Blister packaging (for gums, gummies & premium gifts with purchase)Cup container (for cup-style chips & ice cream)Cylindrical container (for tube snacks & tower-shaped chips)Stick packaging (for long, thin candies)Squeeze jelly pouch (for drinkable gummies & juice-based snacks)Booklet-style packaging (contains stickers/cards when opened)Toy-integrated packaging (with a built-in toy)Novelty-shaped packagingExamples: 3D character face shape, car shape, treasure chest shape, light-up bottle shape, etc.🧭 Scene Optimization RulesAutomatically adjust the following elements to create a high-contrast environment where the package stands out, based on the snack package design and concept:Lighting (brightness, warm/cool tone, direction)Seasonal vibe (summer/winter, spring/autumn)Indoor/outdoor settingTime of day (day/night)`,
    },
    // {
    //     id: 'image-translator',
    //     templateName: 'image-translator',
    //     text: 'image-translator-desc',
    //     preValue: ['placeholder-spanish'],
    //     placeholder: ['placeholder-spanish'],
    //     result: 'Translate all text in the image into [Spanish]. Do not add new content. Keep the original structure and layout.',
    // },
    {
        id: 'action-figure',
        // 命名冲突
        templateName: 'photo-editor-action-figure',
        text: 'action-figure-desc',
        preValue: [],
        placeholder: [],
        result: 'Create a 1/7 scale commercialized figurine of the character in the picture, in a realistic style, in a real environment.  The figurine is placed on a computer desk.  The figurine has a round transparent acrylic base.  The content on the computer screen is a 3D modeling process of this figurine.  Next to the computer screen is a toy packaging box, designed in a style reminiscent of high-quality collectible figures, printed with original artwork.  The packaging features two-dimensional flat illustrations of the figurine.',
    },
    {
        id: 'pet-9-grid-meme',
        templateName: 'pet-9-grid-meme',
        text: 'pet-9-grid-meme-desc',
        preValue: [],
        placeholder: [],
        result: 'This picture has a light orange background and adopts a 3x3 grid layout, showcasing a pet in nine different bread - themed outfits. \nIn the first row, from left to right:\n First, the pet wears a small toast hat and sticks out its tongue, looking cute. \nNext, it dons a bread - patterned outfit and tilts its head, as if acting cute. \nThen, it wears a croissant hair hoop and rubs its face, appearing a bit dull and adorable. \nIn the second row: \nFirst, the pet puts on a baguette - printed sweatshirt and sits properly, looking well - behaved. \nNext, it wears a donut headband and shakes its head, as if playing. \nThen, it wears sandwich - patterned overalls and stands up, showing a lively look. \nIn the third row: \nFirst, the pet wears a small bread hairpin and opens its eyes, looking energetic. \nNext, it wears a shredded pork floss hair band and yawns, showing extreme laziness. \nThen, it rubs against a bread - themed mat, appearing gentle. \nEach bread - themed outfit look is vivid and lively, delicately presenting the pet\'s "cute dullness".  It is a realistic photo.',
    },
    {
        id: 'future-baby',
        templateName: 'future-baby',
        text: 'future-baby-desc',
        preValue: [],
        placeholder: [],
        result: "Combine features from both parents realistically to predict the baby's appearance.",
    },
    {
        id: 'baby-filter',
        templateName: 'baby-filter',
        text: 'baby-filter-desc',
        preValue: [],
        placeholder: [],
        result: 'Change the person in the picture into a two-year-old baby.',
    },
    {
        id: 'ai-group-portrait',
        templateName: 'ai-group-portrait',
        text: 'ai-group-portrait-desc',
        preValue: [],
        placeholder: [],
        result: 'Keep the facial features of the characters in Picture 1 and Picture 2 unchanged. \nPlease merge Picture 1 and Picture 2 into a single overhead self-portrait of the two people. \nIn the picture, with their heads slightly tilted upward to create a strong visual impact. \nThe character on the left should stand slightly forward with their body slightly leaning inward. \nThe photo should be taken from a high angle, which will exaggerate and enlarge the proportion of their heads. \nThe background should be a light white color, simple and clean.',
    },
    {
        id: 'ai-replace',
        templateName: 'ai-replace',
        text: 'ai-replace-desc',
        preValue: ['placeholder-ice-cream', 'placeholder-banana'],
        placeholder: ['placeholder-ice-cream', 'placeholder-banana'],
        result: 'Replace the [ice cream] in the image with a [banana]. Make sure the lighting, shadows, perspective, and style match the rest of the image. Keep the background and other elements unchanged.',
    },
    {
        id: 'sketch-to-image',
        templateName: 'sketch-to-image',
        text: 'sketch-to-image-desc',
        preValue: [],
        placeholder: [],
        result: 'Turn this sketch into a realistic, high-quality image. Preserve the composition and structure of the sketch, and add natural colors, textures, lighting, and depth.',
    },
    {
        id: 'change-background',
        templateName: 'change-background',
        text: 'change-background-desc',
        preValue: ['placeholder-active-sporty'],
        placeholder: ['placeholder-active-sporty'],
        result: 'Replace with an [active, sporty] background. Replace the background of the image while preserving the main subject in its original quality. Ensure the new background matches the lighting, perspective, and style of the subject for a realistic and cohesive result. Blend edges naturally and maintain shadows or reflections if applicable.',
    },
    {
        id: 'interior-design',
        templateName: 'interior-design',
        text: 'interior-design-desc',
        preValue: [
            'placeholder-realistic-and-stylish-living-room-interior-design-in-modern-minimalist-style-with-sleek-lines-neutral-colors-and-open-space',
        ],
        placeholder: [
            'placeholder-realistic-and-stylish-living-room-interior-design-in-modern-minimalist-style-with-sleek-lines-neutral-colors-and-open-space',
        ],
        result: 'Generate a [realistic and stylish living room interior design in modern minimalist style with sleek lines, neutral colors, and open space.] Use a harmonious color palette and a well-balanced layout. The space should feel cozy, modern, and inviting, with attention to textures, materials, and overall atmosphere. High-resolution, photorealistic rendering with soft shadows and realistic depth.',
    },
    // {
    //     id: 'ai-headshot',
    //     templateName: 'ai-headshot',
    //     text: 'ai-headshot-desc',
    //     preValue: ['placeholder-wearing-in-a-navy-blue-suit-with-a-tie-a-white-shirt-neutral-background'],
    //     placeholder: ['placeholder-wearing-in-a-navy-blue-suit-with-a-tie-a-white-shirt-neutral-background'],
    //     result: 'Create an image of a high resolution professional headshot photography [wearing in a navy blue suit with a tie, a white shirt, neutral background] with soft lighting, and soft shadows. Use the attached photo as a reference for the face. High detail, high-resolution photography, waist shot.',
    // },
    {
        id: 'change-season',
        templateName: 'change-season',
        text: 'change-season-desc',
        preValue: ['placeholder-autumn'],
        placeholder: ['placeholder-autumn'],
        result: 'Change the season in the image to [autumn], while preserving the original composition, lighting direction, and key subjects. Adjust environmental elements such as foliage, sky color, ground texture, and overall atmosphere to reflect the new season in a natural and realistic way.',
    },
    {
        id: 'remove-object',
        templateName: 'remove-object',
        text: 'remove-object-desc',
        preValue: ['placeholder-hot-air-balloon'],
        placeholder: ['placeholder-hot-air-balloon'],
        result: 'Remove the [hot air balloon] from the image seamlessly. Fill in the background naturally to match the surrounding environment in terms of texture, lighting, and perspective. Ensure there are no visible traces or artifacts, and the final image looks clean, realistic, and undisturbed.',
    },
    {
        id: 'ai-filter',
        templateName: 'ai-filter',
        text: 'ai-filter-desc',
        preValue: ['placeholder-Ghibli-style'],
        placeholder: ['placeholder-Ghibli-style'],
        result: 'Change the style of the image to [Ghibli style] while preserving the main composition and subject. Apply consistent changes in color tone, texture, lighting, and artistic details to reflect the new style. Ensure the transformation looks cohesive, visually appealing, and true to the chosen aesthetic.',
    },
    {
        id: 'ai-hairstyle',
        templateName: 'ai-hairstyle',
        text: 'ai-hairstyle-desc',
        preValue: ['placeholder-short-bob-cut'],
        placeholder: ['placeholder-short-bob-cut'],
        result: 'Change the hairstyle of the person in the image with [short bob cut] while keeping their facial features, expression, pose, and lighting consistent. Ensure the new hairstyle looks natural and realistic, with appropriate hair texture, shadows, and alignment with the head shape. Maintain the overall image quality and style.',
    },
    {
        id: 'beauty-analyzer',
        templateName: 'beauty-analyzer',
        text: 'beauty-analyzer-desc',
        preValue: [],
        placeholder: [],
        result: 'Use the provided portrait photo as the base.Do NOT change the person’s face, expression, age, skin tone or gender. Just overlay a clean, minimal infographic on top.Create a high-resolution vertical “FACIAL AESTHETIC REPORT” poster, studio lighting, soft beige background, premium beauty clinic style.The subject can be MALE or FEMALE – keep them exactly as in the original photo.Add thin white lines and labels pointing to each area of the REAL face, with percentage scores based on global aesthetic ratios, symmetry and proportions (do not change the face):Eyes:Label near the eyes with a line pointing to them:“Eyes Beauty – 0-100%”Example: “Eyes Beauty – 92%”Cheeks:Label near the cheekbones:“Cheeks Harmony – 0-100%”Example: “Cheeks Harmony – 85%”Lips:Label close to the mouth:“Lips Shape – 0-100%”Example: “Lips Shape – 88%”Eyebrows:Label above or beside the brows:“Eyebrows Design – 0-100%”Example: “Eyebrows Design – 80%”Jaw & Chin:Label near the jawline and chin:“Jaw & Chin Definition – 0-100%”Example: “Jaw & Chin Definition – 90%”Overall Facial Symmetry:Label near the center of the face:“Facial Symmetry – 0-100%”Example: “Facial Symmetry – 89%”At the bottom center of the poster, add a BIG, bold number inside a circle or rectangle:“OVERALL SCORE: XX%”This is the total facial aesthetic score from 1-100%.Design style:– clean, medical-grade, aesthetic-clinic infographic– modern thin sans-serif typography– white text and lines, subtle drop shadows– no logos, no extra graphics, no text other than the labels and scores above.',
    },
    // {
    //     id: 'ai-clothes-changer',
    //     templateName: 'ai-clothes-changer',
    //     text: 'ai-clothes-changer-desc',
    //     preValue: ['placeholder-formal-business-suit'],
    //     placeholder: ['placeholder-formal-business-suit'],
    //     result: 'Change the clothing of the person in the image with [formal business suit] while keeping their face, body posture, lighting, and overall style consistent. Ensure the new outfit looks natural, well-fitted, and realistic, with appropriate fabric texture, shadows, and folds. Maintain harmony with the original background and scene.',
    // },
    {
        id: 'change-color',
        templateName: 'change-color',
        text: 'change-color-desc',
        preValue: ['placeholder-person-s-clothing', 'placeholder-soft-pastel-pink'],
        placeholder: ['placeholder-person-s-clothing', 'placeholder-soft-pastel-pink'],
        result: "Change the color of the [person's clothing] in the image to [soft pastel pink], while keeping the fabric texture, lighting, shading, and folds realistic. Ensure the new color blends naturally with the original style of the image and maintains visual harmony with the surrounding elements.",
    },
    {
        id: 'ai-texture',
        templateName: 'ai-texture',
        text: 'ai-texture-desc',
        preValue: ['placeholder-object', 'placeholder-smooth-polished-metal'],
        placeholder: ['placeholder-object', 'placeholder-smooth-polished-metal'],
        result: 'Change the texture of the [object] in the image to [smooth polished metal], while preserving its shape, lighting, perspective, and surrounding environment. Apply realistic surface details, reflections, shadows, and material properties that match the new texture type. Ensure the transformation looks natural and seamless within the context of the original image.',
    },
    {
        id: 'colorize-photo',
        templateName: 'colorize-photo',
        text: 'colorize-photo-desc',
        preValue: ['placeholder-realistic-and-natural'],
        placeholder: ['placeholder-realistic-and-natural'],
        result: 'Colorize the image with [realistic and natural] colors. Apply accurate skin tones, fabric colors, and environmental hues based on typical lighting and materials. Maintain the original details, shading, and textures to create a lifelike and historically respectful result.',
    },
    {
        id: 'edit-text',
        templateName: 'edit-text',
        text: 'edit-text-desc',
        preValue: [
            'placeholder-AD-TRENDS',
            'placeholder-Sweet-Life',
            'placeholder-handwriting',
            'placeholder-original',
            'placeholder-original',
        ],
        placeholder: [
            'placeholder-AD-TRENDS',
            'placeholder-Sweet-Life',
            'placeholder-handwriting',
            'placeholder-original',
            'placeholder-original',
        ],
        result: 'Replace [AD Trends] with [Sweet Life], using a [handwriting] font style, with the [original] size and [original] color. Keep all other elements of the image unchanged.',
    },
    // {
    //     id: 'face-retouch',
    //     templateName: 'face-retouch',
    //     text: 'face-retouch-desc',
    //     preValue: [
    //         'placeholder-smooth-skin-texture-naturally-remove-blemishes-and-wrinkles-even-out-skin-tone-brighten-the-eyes-and-teeth',
    //     ],
    //     placeholder: [
    //         'placeholder-smooth-skin-texture-naturally-remove-blemishes-and-wrinkles-even-out-skin-tone-brighten-the-eyes-and-teeth',
    //     ],
    //     result: '[Smooth skin texture naturally, remove blemishes and wrinkles, even out skin tone, brighten the eyes and teeth], adjust lighting and contrast for a polished, high-end magazine-quality look. Maintain natural facial features and realism. Enhance the overall appearance of the photo with professional retouching.',
    // },
    // {
    //     id: 'change-expression',
    //     templateName: 'change-expression',
    //     text: 'change-expression-desc',
    //     preValue: ['placeholder-laugh'],
    //     placeholder: ['placeholder-laugh'],
    //     result: 'Adjust the expression to [laugh]. Ensuring smooth blending and appropriate muscle movements around the eyes, mouth, and brows. Change the facial expression of the person in the image while keeping the rest of the facial features, pose, and lighting consistent. Maintain a realistic and natural appearance.',
    // },
    // {
    //     id: 'gender-swap',
    //     templateName: 'gender-swap',
    //     text: 'gender-swap-desc',
    //     preValue: ['placeholder-female', 'placeholder-male'],
    //     placeholder: ['placeholder-female', 'placeholder-male'],
    //     result: 'Change the gender of the person in the image from [female] to [male] while maintaining their original facial identity, pose, and expression. Ensure the transformation looks realistic and natural, adjusting facial features, hairstyle, clothing, and subtle details such as jawline, eyebrows, and body shape to match the target gender. Preserve lighting, background, and overall image style.',
    // },
];

// 随机灵感
export const AI_PHOTO_EDITOR_INSPIRATIONS = [
    'Make this image look like it was taken in the 1950s',
    'Add a dramatic sunset background',
    'Transform this into a cartoon style',
    'Make this look like a professional portrait',
    'Add a vintage film grain effect',
    'Change the lighting to be more dramatic',
    'Make this look like a watercolor painting',
    'Add a dreamy, ethereal atmosphere',
    'Transform this into a cyberpunk style',
    'Make this look like an oil painting',
];

export const AI_PHOTO_EDITOR_MODEL_FILTERS = [
    { label: 'all', value: CATEGORIES.ALL },
    { label: '720p', value: CATEGORIES.P720 },
    { label: '1080p', value: CATEGORIES.P1080 },
    { label: '2k', value: CATEGORIES.K2 },
    { label: '4k', value: CATEGORIES.K4 },
    { label: 'reference', value: CATEGORIES.REFERENCE },
    { label: 'text-prompt', value: CATEGORIES.TEXT_PROMPT },
];

export default {
    SMART_IMAGE_INSTRUCTION_TEMPLATES,
    AI_PHOTO_EDITOR_INSPIRATIONS,
};

export const AI_PHOTO_EDITOR_MODELS_VALUE = {
    GOOGLE_NANO_BANANA: 'google-nano-banana',
    GOOGLE_NANO_BANANA_PRO: 'google-nano-banana-pro',
    OPENAI_GPT_IMAGE_1: 'openai-gpt-image-1',
    OPENAI_GPT_IMAGE_1_5: 'openai-gpt-image-1.5',
    OPENAI_GPT_IMAGE_1_PLUS: 'openai-gpt-image-1-plus',
    BYTEDANCE_SEEDEDIT_3_0: 'bytedance-seededit-3.0',
    BYTEDANCE_SEEDREAM_4: 'bytedance-seedream-4',
    BYTEDANCE_SEEDREAM_4_5: 'bytedance-seedream-4.5',
    KLING_IMAGE_O1: 'kling-vo1',
    FLUX_KONTEXT_DEV: 'flux-kontext-dev',
    FLUX_KONTEXT_PRO: 'flux-kontext-pro',
    FLUX_KONTEXT_MAX: 'flux-kontext-max',
    QWEN_IMAGE_EDIT: 'qwen-image-edit',
    QWEN_IMAGE_EDIT_PLUS: 'qwen-image-edit-plus',
    FLUX_2_FLEX: 'flux-2-flex',
    FLUX_2_PRO: 'flux-2-pro',
};

export const AI_PHOTO_EDITOR_MODELS = [
    {
        name: 'Google Nano Banana Pro',
        renderIcon: FJAIPhotoEditorConfig.modelIconPath + 'google.png' + `?v=${FJConfig.version}`,
        useCredit: 10,
        value: AI_PHOTO_EDITOR_MODELS_VALUE.GOOGLE_NANO_BANANA_PRO,
        description: 'google-nano-banana-pro-desc',
        supportImageReferenceNum: 10,
        supportRatios: ['auto', '1:1', '2:3', '3:2', '3:4', '4:3', '4:5', '5:4', '9:16', '16:9', '21:9'],
        supportResolutions: [
            {
                shortName: '1K',
                name: '1K <span>(1080px)</span>',
                value: '1K',
            },
            {
                shortName: '2K',
                name: '2K <span>(2048px)</span>',
                value: '2K',
            },
            {
                shortName: '4K',
                name: '4K <span>(4096px)</span>',
                value: '4K',
            },
        ],
        creditPriceLevels: {
            '1K': 12,
            '2K': 14,
            '4K': 16,
        },
        needTranslate: false,
        promptCharacterLimit: 5000,
        categorys: [CATEGORIES.P1080, CATEGORIES.K2, CATEGORIES.K4, CATEGORIES.SHOTS, CATEGORIES.TEXT_PROMPT],
        tags: [TAGS.K4, TAGS.SHOTS, TAGS.TEXT_PROMPT],
    },
    {
        name: 'OpenAI GPT Image 1.5',
        renderIcon: FJAIPhotoEditorConfig.modelIconPath + 'openai.png' + `?v=${FJConfig.version}`,
        useCredit: 6,
        value: AI_PHOTO_EDITOR_MODELS_VALUE.OPENAI_GPT_IMAGE_1_5,
        description: 'openai-gpt-image-1.5-desc',
        supportImageReferenceNum: 10,
        supportRatios: ['1:1', '2:3', '3:2'],
        supportResolutionsTitle: 'quality',
        supportResolutions: [
            {
                name: 'low',
                value: 'low',
            },
            {
                name: 'medium',
                value: 'medium',
            },
            {
                name: 'high',
                value: 'high',
            },
        ],
        creditPriceLevels: {
            low: 6,
            medium: 8,
            high: 10,
        },
        maxImagesPerRequest: 4,
        needTranslate: false,
        isNew: true,
        promptCharacterLimit: 5000,
        categorys: [CATEGORIES.P1080, TAGS.REFERENCE, TAGS.TEXT_PROMPT],
        tags: [TAGS.P1080, TAGS.REFERENCE, TAGS.TEXT_PROMPT],
    },
    {
        name: 'Bytedance Seedream 4.5',
        renderIcon: FJAIPhotoEditorConfig.modelIconPath + 'byte.png' + `?v=${FJConfig.version}`,
        useCredit: 4,
        value: AI_PHOTO_EDITOR_MODELS_VALUE.BYTEDANCE_SEEDREAM_4_5,
        description: 'bytedance-seedream-4.5-desc',
        supportImageReferenceNum: 10,
        supportRatios: ['1:1', '4:3', '3:4', '16:9', '9:16', '3:2', '2:3', '21:9'],
        // supportResolutions: [
        //     {
        //         shortName: '2K',
        //         name: '2K <span>(2048px)</span>',
        //         value: '2K',
        //     },
        //     {
        //         shortName: '4K',
        //         name: '4K <span>(4096px)</span>',
        //         value: '4K',
        //     },
        // ],
        needTranslate: false,
        promptCharacterLimit: 5000,
        categorys: [CATEGORIES.K2, CATEGORIES.K4, CATEGORIES.REFERENCE, CATEGORIES.TEXT_PROMPT],
        tags: [TAGS.K4, TAGS.REFERENCE, TAGS.TEXT_PROMPT],
    },
    {
        name: 'Kling Image O1',
        renderIcon: FJAIPhotoEditorConfig.modelIconPath + 'kling.png' + `?v=${FJConfig.version}`,
        useCredit: 3,
        value: AI_PHOTO_EDITOR_MODELS_VALUE.KLING_IMAGE_O1,
        description: 'kling-image-o1-desc',
        supportImageReferenceNum: 10,
        supportRatios: ['16:9', '9:16', '1:1', '4:3', '3:4', '3:2', '2:3', '21:9'],
        supportResolutions: [
            {
                shortName: '1K',
                name: '1K <span>(1080px)</span>',
                value: '1K',
            },
            {
                shortName: '2K',
                name: '2K <span>(2048px)</span>',
                value: '2K',
            },
        ],
        needTranslate: false,
        isNew: true,
        promptCharacterLimit: 2500,
        categorys: [CATEGORIES.K2, TAGS.REFERENCE],
        tags: [TAGS.K2, TAGS.REFERENCE],
    },
    {
        name: 'Flux 2 Pro',
        renderIcon: FJAIPhotoEditorConfig.modelIconPath + 'flux.png' + `?v=${FJConfig.version}`,
        useCredit: 2,
        value: AI_PHOTO_EDITOR_MODELS_VALUE.FLUX_2_PRO,
        description: 'flux-2-pro-desc',
        supportRatios: ['auto', '1:1', '16:9', '3:2', '2:3', '4:5', '5:4', '9:16', '3:4', '4:3'],
        supportImageReferenceNum: 6,
        needTranslate: false,
        promptCharacterLimit: 5000,
        categorys: [CATEGORIES.P1080, TAGS.REFERENCE],
        tags: [TAGS.P1080, TAGS.REFERENCE],
    },
    // {
    //     name: 'Qwen-Image-Edit-Plus',
    //     renderIcon: FJAIPhotoEditorConfig.modelIconPath + 'alibaba.png' + `?v=${FJConfig.version}`,
    //     useCredit: 6,
    //     value: AI_PHOTO_EDITOR_MODELS_VALUE.QWEN_IMAGE_EDIT_PLUS,
    //     description: 'qwen-image-plus-desc',
    // supportImageReferenceNum:5,
    //     needTranslate: true,
    // },
    {
        name: 'Qwen Image Edit',
        renderIcon: FJAIPhotoEditorConfig.modelIconPath + 'alibaba.png' + `?v=${FJConfig.version}`,
        useCredit: 3,
        value: AI_PHOTO_EDITOR_MODELS_VALUE.QWEN_IMAGE_EDIT,
        description: 'qwen-image-desc',
        supportImageReferenceNum: 1,
        needTranslate: false,
        promptCharacterLimit: 5000,
        categorys: [CATEGORIES.P1080, TAGS.TEXT_PROMPT],
        tags: [TAGS.P1080, TAGS.TEXT_PROMPT],
    },
    {
        name: 'Google Nano Banana',
        renderIcon: FJAIPhotoEditorConfig.modelIconPath + 'google.png' + `?v=${FJConfig.version}`,
        useCredit: 4,
        value: AI_PHOTO_EDITOR_MODELS_VALUE.GOOGLE_NANO_BANANA,
        description: 'google-nano-banana-desc',
        supportImageReferenceNum: 5,
        needTranslate: false,
        promptCharacterLimit: 5000,
        categorys: [CATEGORIES.P1080, TAGS.REFERENCE],
        tags: [TAGS.P1080, TAGS.REFERENCE],
    },
    {
        name: 'OpenAI GPT Image 1',
        renderIcon: FJAIPhotoEditorConfig.modelIconPath + 'openai.png' + `?v=${FJConfig.version}`,
        useCredit: 4,
        value: AI_PHOTO_EDITOR_MODELS_VALUE.OPENAI_GPT_IMAGE_1,
        description: 'openai-gpt-image-1-desc',
        supportImageReferenceNum: 5,
        needTranslate: false,
        promptCharacterLimit: 5000,
        categorys: [CATEGORIES.P1080, TAGS.REFERENCE],
        tags: [TAGS.P1080, TAGS.REFERENCE],
    },
    {
        name: 'Flux 2 Flex',
        renderIcon: FJAIPhotoEditorConfig.modelIconPath + 'flux.png' + `?v=${FJConfig.version}`,
        useCredit: 6,
        value: AI_PHOTO_EDITOR_MODELS_VALUE.FLUX_2_FLEX,
        description: 'flux-2-flex-desc',
        supportImageReferenceNum: 10,
        supportRatios: ['auto', '1:1', '16:9', '3:2', '2:3', '4:5', '5:4', '9:16', '3:4', '4:3'],
        needTranslate: false,
        promptCharacterLimit: 5000,
        categorys: [CATEGORIES.P1080, TAGS.REFERENCE],
        tags: [TAGS.P1080, TAGS.FAST, TAGS.REFERENCE],
    },
    // {
    //     name: 'Flux-Kontext-Dev',
    //     renderIcon: FJAIPhotoEditorConfig.modelIconPath + 'flux.png' + `?v=${FJConfig.version}`,
    //     useCredit: 4,
    //     value: AI_PHOTO_EDITOR_MODELS_VALUE.FLUX_KONTEXT_DEV,
    //     description: 'flux-kontext-dev-desc',
    //     supportImageReferenceNum: 1,
    //     needTranslate: true,
    // },
    {
        name: 'Flux Kontext Pro',
        renderIcon: FJAIPhotoEditorConfig.modelIconPath + 'flux.png' + `?v=${FJConfig.version}`,
        useCredit: 4,
        value: AI_PHOTO_EDITOR_MODELS_VALUE.FLUX_KONTEXT_PRO,
        description: 'flux-kontext-pro-desc',
        supportImageReferenceNum: 1,
        needTranslate: true,
        promptCharacterLimit: 5000,
        categorys: [CATEGORIES.P720],
        tags: [TAGS.P720, TAGS.FAST],
    },
    // {
    //     name: 'Flux-Kontext-Max',
    //     renderIcon: FJAIPhotoEditorConfig.modelIconPath + 'flux.png' + `?v=${FJConfig.version}`,
    //     useCredit: 16,
    //     value: AI_PHOTO_EDITOR_MODELS_VALUE.FLUX_KONTEXT_MAX,
    //     description: 'flux-kontext-max-desc',
    //     supportImageReferenceNum: 1,
    //     needTranslate: true,
    // },
    {
        name: 'Bytedance Seedream 4',
        renderIcon: FJAIPhotoEditorConfig.modelIconPath + 'byte.png' + `?v=${FJConfig.version}`,
        useCredit: 6,
        value: AI_PHOTO_EDITOR_MODELS_VALUE.BYTEDANCE_SEEDREAM_4,
        description: 'bytedance-seedream-4-desc',
        supportImageReferenceNum: 5,
        needTranslate: false,
        promptCharacterLimit: 5000,
        categorys: [CATEGORIES.P1080, CATEGORIES.K2, CATEGORIES.K4, CATEGORIES.REFERENCE],
        supportRatios: ['1:1', '16:9', '9:16', '2:3', '3:2', '4:3', '3:4'],
        tags: [TAGS.K4, TAGS.REFERENCE],
    },
    // {
    //     name: 'Bytedance Seededit 3.0',
    //     renderIcon: FJAIPhotoEditorConfig.modelIconPath + 'byte.png' + `?v=${FJConfig.version}`,
    //     useCredit: 3,
    //     value: AI_PHOTO_EDITOR_MODELS_VALUE.BYTEDANCE_SEEDEDIT_3_0,
    //     description: 'bytedance-seededit-3-0-desc',
    //     supportImageReferenceNum: 1,
    //     needTranslate: false,
    //     promptCharacterLimit: 5000,
    //     categorys: [CATEGORIES.P720, TAGS.TEXT_PROMPT],
    //     tags: [TAGS.P720, TAGS.TEXT_PROMPT],
    // },
];
// 已下架的模型映射对应模型
export const OUT_MODEL_MAP = {
    [AI_PHOTO_EDITOR_MODELS_VALUE.BYTEDANCE_SEEDEDIT_3_0]: AI_PHOTO_EDITOR_MODELS_VALUE.BYTEDANCE_SEEDREAM_4_5,
};
export const AI_PHOTO_EDITOR_MAX_IMAGES = 14;
